export type PlayerEngineName = 'letterbox' | 'pillarbox';

declare global {
  interface Window {
    rioPlayerEngineOverride?: PlayerEngineName;
  }
}

const parsePlayerEngine = (value: string | null): PlayerEngineName | undefined =>
  value === 'letterbox' || value === 'pillarbox' ? value : undefined;

export const getPlayerEngineOverride = (): PlayerEngineName | undefined => {
  if (typeof window === 'undefined') return undefined;
  return window.rioPlayerEngineOverride ?? parsePlayerEngine(new URLSearchParams(window.location.search).get('playerEngine'));
};

if (typeof window !== 'undefined' && typeof window.location?.search === 'string') {
  window.rioPlayerEngineOverride = parsePlayerEngine(new URLSearchParams(window.location.search).get('playerEngine'));
}
